import { render, staticRenderFns } from "./smallView.vue?vue&type=template&id=578007d1&scoped=true"
import script from "./smallView.vue?vue&type=script&setup=true&lang=js"
export * from "./smallView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./smallView.vue?vue&type=style&index=0&id=578007d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578007d1",
  null
  
)

export default component.exports